<template>
    <div class="container flex flex-direction">
        <a :href="`/digitize/all${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`"
            style="position: fixed;top: 20px;left: 20px;width: 150px;height: 40px;text-align: center;line-height: 40px;background: rgba(255,255,255,.2);color: #fff;font-size: 20px;border-radius: 10px;">返回</a>
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="page-title self-center">首华·双暖为老志愿服务队建设数据</div>
        <div class="total-container flex">
            <div class="title">实时数据</div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_building_1.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{ style: style, number: [team_num], content: '{nt}' }" class="number" />
                        <div class="label margin-left-xs">个</div>
                    </div>
                    <div class="label max margin-top-xs">队伍列表</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_building_2.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{ style: style, number: [quyu_num], content: '{nt}' }" class="number" />
                        <div class="label margin-left-xs">个</div>
                    </div>
                    <div class="label max margin-top-xs">覆盖区域</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_building_3.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{ style: style, number: [jiedao_num], content: '{nt}' }" class="number" />
                        <div class="label margin-left-xs">个</div>
                    </div>
                    <div class="label max margin-top-xs">覆盖街道（乡镇）</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_building_4.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{ style: style, number: [shequ_num], content: '{nt}' }" class="number" />
                        <div class="label margin-left-xs">个</div>
                    </div>
                    <div class="label max margin-top-xs">覆盖社区（村）</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_building_5.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{ style: style, number: [zhuhu_num], content: '{nt}' }" class="number" />
                        <div class="label margin-left-xs">户</div>
                    </div>
                    <div class="label max margin-top-xs">覆盖住户</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_building_6.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{ style: style, number: [served_num], content: '{nt}' }" class="number" />
                        <div class="label margin-left-xs">名</div>
                    </div>
                    <div class="label max margin-top-xs">认证服务对象</div>
                </div>
            </div>
        </div>
        <div class="flex-sub flex margin-top-sm">
            <dv-border-box-10 class="map title-container flex-sub" :color="['#fa9d1b', 'yellow']"
                backgroundColor="transparent">
                <div class="bg-title">
                    <div class="title">覆 盖</div>
                </div>
                <building-map @chioseAddress="chioseAddress"></building-map>
            </dv-border-box-10>
            <div class="flex-twice flex flex-direction margin-left-sm">
                <dv-border-box-10 class="white title-container flex-sub flex flex-direction"
                    :color="['#fa9d1b', 'yellow']" backgroundColor="transparent">
                    <div class="bg-title">
                        <div class="title">详 情</div>
                    </div>
                    <div class="margin-top-xl margin-bottom-sm">
                        <el-table class="flex-sub" v-loading="loading" :data="lists" :row-class-name="tableRowClassName"
                            header-row-class-name="table-header" height="330" style="width: 100%">
                            <el-table-column label="序号" prop="title" width="100">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        {{ scope.$index + 1 }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="社区名称" prop="level" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div class="table-item ovHide">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="全部区域" prop="level" width="100">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        {{ scope.row.xian_name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="服务队名称" prop="level" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div class="table-item ovHide">
                                        <p class="ovHide margin-tb-xs" v-for="(item, index) in scope.row.service_team"
                                            :key="index">
                                            {{ item.name }}
                                        </p>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column label="队员数量" prop="level" width="200">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        <p class="ovHide margin-tb-xs" v-for="(item, index) in scope.row.service_team"
                                            :key="index">
                                            {{ item.member_num }}
                                        </p>
                                    </div>
                                </template>
                            </el-table-column>
                            <!--              <el-table-column label="服务次数" prop="level" width="100">-->
                            <!--                <template slot-scope="scope">-->
                            <!--                  <div class="table-item">-->
                            <!--                    <p class="ovHide margin-tb-xs" v-for="(item,index) in scope.row.service_team" :key="index">-->
                            <!--                      {{item.service_num}}-->
                            <!--                    </p>-->
                            <!--                  </div>-->
                            <!--                </template>-->
                            <!--              </el-table-column>-->
                            <!--              <el-table-column label="服务项数" prop="level" width="100">-->
                            <!--                <template slot-scope="scope">-->
                            <!--                  <div class="table-item">-->
                            <!--                    <p class="ovHide margin-tb-xs" v-for="(item,index) in scope.row.service_team" :key="index">-->
                            <!--                      {{item.service_detail_num}}-->
                            <!--                    </p>-->
                            <!--                  </div>-->
                            <!--                </template>-->
                            <!--              </el-table-column>-->
                        </el-table>
                    </div>
                </dv-border-box-10>
                <dv-border-box-10 class="title-container flex-sub margin-top-sm" :color="['#fa9d1b', 'yellow']"
                    backgroundColor="transparent">
                    <div class="bg-title">
                        <div class="title">进 度</div>
                    </div>
                    <el-dropdown class="years" trigger="click" @command="yearChange">
                        <span class="el-dropdown-link">
                            {{ year }}年<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item, index) in years" :key="index" :command="item">
                                <p style="width: 50px;">{{ item.year }}年</p>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div id="line-echarts" class="echarts padding-top-xl padding-lr-sm padding-bottom-sm"></div>
                </dv-border-box-10>
            </div>
        </div>
    </div>
</template>

<script>
import BuildingMap from "@/views/digitize/components/BuildingMap";
import { getYear, getYears } from "@/utils/utils";
import * as echarts from 'echarts'
import { serviceTeamData } from "@/api/weilao";

export default {
    name: "building",
    components: { BuildingMap },
    data() {
        return {
            xiangmu_id: '',
            style: {
                width: '150px',
                fontSize: 30,
                fill: '#ffd800',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold'
            },

            jiedao_num: 0,
            quyu_num: 0,
            served_num: 0,
            shequ_num: 0,
            team_num: 0,
            zhuhu_num: 0,

            lists: [],
            loading: false,
            line_echarts: '',
            year: getYear(),
            years: getYears(),
            option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                color: [{
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#ffcc00' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#e16811' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                }],
                textStyle: {
                    color: '#ffffff',
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    bottom: '0%',
                    containLabel: true
                },
                xAxis: {
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                            width: 5,
                        }
                    },
                    type: 'category',
                    axisLabel: {
                        fontSize: 10
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true, //去除刻度线
                        lineStyle: {
                            color: '#fff',
                            type: 'dotted',
                            dashOffset: 2
                        }
                    },
                    axisTick: {
                        show: true //去除刻度线
                    },
                    axisLine: {
                        show: true, //去除轴线
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                },
                series: {
                    data: [],
                    type: 'bar',
                    barWidth: '30%',
                    label: {
                        show: false,
                        position: 'top',
                        valueAnimation: true
                    },
                    itemStyle: {
                        normal: {
                            label: {
                                formatter: "{c}" + "",
                                show: true,
                                position: "top",
                                textStyle: {
                                    fontWeight: "bolder",
                                    fontSize: "12",
                                    color: "#fff"
                                }
                            },
                        }
                    }
                }
            },
        }
    },
    mounted() {
        this.xiangmu_id = this.$route.query.xiangmu_id
        this.init()
    },
    methods: {
        async chioseAddress(arr) {
            this.loading = true
            const res = await serviceTeamData(this.year, arr[0], arr[1])
            this.lists = res.data.xiaoqu_arr
            this.loading = false
        },
        //  获取数据
        async init() {
            this.loading = true
            this.line_echarts = echarts.init(document.getElementById('line-echarts'))
            const res = await serviceTeamData(this.year, '', '', this.xiangmu_id)
            this.team_num = res.data.team_num
            // this.quyu_num = res.data.quyu_num
            this.quyu_num = 1
            this.jiedao_num = res.data.jiedao_num
            this.shequ_num = res.data.shequ_num
            this.zhuhu_num = res.data.zhuhu_num
            this.served_num = res.data.served_num
            this.lists = res.data.xiaoqu_arr
            this.loading = false
            let _number = [], _name = []
            res.data.team_num_arr.map(item => {
                _number.push(item.team_num)
                _name.push(item.month)
            })
            let _data = {
                number: _number,
                name: _name
            }
            _data.number = _data.number.map((item) => {
                return {
                    value: item
                }
            })
            this.option.xAxis.data = _data.name
            this.option.series.data = _data.number
            this.line_echarts.setOption(this.option)
        },
        yearChange(e) {
            console.log(e)
            this.year = e.year
            this.init()
        },
        tableRowClassName({ rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'red'
            } else {
                return 'transparent'
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    background: url(../../../assets/img/data/bg_data.jpg) no-repeat top;
    background-size: 100% 100%;
    height: 1080px;
    width: 1920px;
    overflow: hidden;
    padding: 0 35px 30px;

    .loading {
        color: #ffffff;
        position: fixed;
    }

    .page-title {
        font-size: 36px;
        line-height: 36px;
        color: transparent;
        -webkit-background-clip: text;
        background-image: linear-gradient(0deg,
                #ffd800 0%,
                #ffec83 50%,
                #ffffff 100%);
        background-blend-mode: normal, normal;
        margin-top: 25px;
        font-weight: bold;
    }

    .total-container {
        height: 121px;
        background-color: #ffffff88;
        box-shadow: inset 0px 83px 150px 0px #c33c0d;
        border: solid 1px #fa9d1b;
        margin-top: 35px;

        .title {
            font-size: 20px;
            writing-mode: vertical-lr;
            text-align: center;
            line-height: 53px;
            color: #ffffff;
            width: 53px;
            height: 121px;
            background-image: linear-gradient(#c63c0d,
                    #c63c0d),
                linear-gradient(#000000,
                    #000000);
            background-blend-mode: normal,
                normal;
            box-shadow: inset 0px 0px 10px 0px #ec8914;
            border: solid 2px #fa9d1b;
        }

        .number-item {
            .label {
                font-size: 14px;
                color: #ffffff;

                &.max {
                    font-size: 16px;
                }
            }

            .icon {
                width: 63px;
                height: 63px;
            }

            .number {
                width: 120px;
                height: 36px;
            }
        }

    }

    .title-container {
        .border-box-content {
            position: relative;
        }

        .years {
            position: absolute;
            right: 20px;
            top: 20px;
            width: 96px;
            height: 26px;
            line-height: 26px;
            border-radius: 15px;
            border: solid 1px #ffffff;
            text-align: center;
            color: #FFFFFF;
            cursor: pointer;
        }

        .bg-title {
            z-index: 99;
            width: 556px;
            text-align: center;
            height: 44px;
            line-height: 44px;
            position: absolute;
            background: url(../../../assets/img/data/bg_title.png) no-repeat top;
            background-size: 100% auto;
            left: 50%;
            transform: translateX(-50%);

            .title {
                line-height: 44px;
                font-size: 24px;
                color: transparent;
                -webkit-background-clip: text;
                background-image: linear-gradient(0deg,
                        #ffd800 0%,
                        #ffec83 50%,
                        #ffffff 100%);
                background-blend-mode: normal, normal;
                font-weight: bold;
            }
        }

    }

    .echarts {
        width: 100%;
        height: 100%;
        background: transparent;
    }

    .map {
        background: url(../../../assets/img/data/bg_map.png) no-repeat top;
        background-size: 100% 100%;
    }

    .dv-border-box-10 {
        background: #b73d0f;
        box-shadow: #fa9d1b55 0px 0px 0px 1px inset !important;
    }
}
</style>
